// start:ng42.barrel
export * from './stay-pref.module';
export * from './stay-pref';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/stay-pref/index.ts